// extracted by mini-css-extract-plugin
export default {"header":"header_header__TRXcv","logo":"header_logo__I8ERj","textGroup":"header_textGroup__R7nml","border":"header_border__yKmZV"};